/* A control that stands INSIDE a sentence — „…pasek pokaże postęp po pierwszym zapisie · Otwórz
 * Pomiary", „Nie udało się wczytać ankiet. Spróbuj ponownie."
 *
 * It is a `<button>` because it acts rather than navigates, and it is set in the sentence's own
 * size so the line it is in does not grow around it. A class-only stylesheet rather than a
 * component, for the reason `iconButton.module.css` gives: the GEOMETRY of the sentence it stands
 * in belongs to the surface, and there is no behaviour here to own.
 *
 * `--accent-ink` and not `--accent-text`: this is the accent as WORDS, and the mark colour measures
 * 3.98:1 against the grounds these sentences stand on. The token's own comment in `tokens/colors.css`
 * says the same thing.
 *
 * ── `--inline-text-ink`, and the one surface that sets it ───────────────────────────────────
 * Added 17 September 2026 for the exercise theatre. The accent appears NOWHERE on that card — the
 * ownership action is a ghost, the „Podobne ćwiczenia" sparkle is a grey pill by owner decision D6,
 * and the specimen writes its own `.mb-text-btn` in `--text-2` — so „Dodaj link" and „Przywróć
 * wersję z biblioteki" would have been the only ember on a surface whose whole rule is that there
 * is none. A custom property rather than a second stylesheet: a caller may change the INK and
 * nothing else, and a module redeclaring `color` beside this one would be settled by chunk order.
 *
 * The default is unchanged, so every other consumer moves by nothing. */
.inlineTextButton {
  padding: var(--space-0);
  font-family: var(--font-body);
  font-size: inherit;
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--inline-text-ink, var(--accent-ink));
  cursor: pointer;
  background: none;
  border: none;
}

.inlineTextButton:focus-visible {
  outline: var(--border-focus) solid var(--accent);
  outline-offset: var(--space-2px);
}
